import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA ,NO_ERRORS_SCHEMA} from '@angular/core';
import { FormsModule,ReactiveFormsModule  } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { SharedModule } from './shared/shared.module';
import { BreadcrumbsComponent } from './layouts/admin/breadcrumbs/breadcrumbs.component';
import { TitleComponent } from './layouts/admin/title/title.component';
import {ScrollModule} from './scroll/scroll.module';
import {LocationStrategy, PathLocationStrategy,HashLocationStrategy} from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import {AgmCoreModule,MapsAPILoader,GoogleMapsAPIWrapper  } from '@agm/core';
import { UiSwitchModule } from 'ngx-ui-switch';

import { OnlynumbersDirective } from '../app/directives/onlynumbers.directive';
import { StuenquirypgComponent } from './stuenquirypg/stuenquirypg.component';



//import { SelectDropDownModule } from 'ngx-select-dropdown';


// import { MorrisJsModule } from 'angular-morris-js';

@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    BreadcrumbsComponent,
    TitleComponent,
   
    OnlynumbersDirective,
   
   
  
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    RouterModule.forRoot(AppRoutes),
    FormsModule,
    ReactiveFormsModule ,
    HttpModule,
    HttpClientModule,
    ScrollModule,
    //AgmCoreModule.forRoot(),

    AgmCoreModule.forRoot({apiKey: 'AIzaSyBjPKBBcKHB8wdGHFB9gVhsxgwTVz-X2xM', libraries: ["places",'geometry']}),
    UiSwitchModule
   // SelectDropDownModule
  ],
  exports: [ScrollModule],
  providers: [GoogleMapsAPIWrapper,
      { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  schemas:  [ CUSTOM_ELEMENTS_SCHEMA ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// D:/Angular projects/memberreg/memberreg/src/app/app.module.ts